var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDlsGlyphDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m14.709 4.2914c-0.38841-0.38853-1.024-0.38853-1.4124 0l-5.2963 5.298-5.2963-5.298c-0.38841-0.38853-1.024-0.38853-1.4124 0-0.38841 0.38853-0.38841 1.0243 0 1.4128l6.0025 6.0044c0.38841 0.38853 1.0239 0.38853 1.4123 0l6.0025-6.0044c0.38841-0.38852 0.38841-1.0243 1e-6 -1.4128z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlsGlyphDown);
export default __webpack_public_path__ + "static/media/dls-glyph-down.18305c0379b5373912af2ebdb9099d88.svg";
export { ForwardRef as ReactComponent };